'use client';

import React, { useId, useRef } from 'react';

import { useBooleanState } from './useBooleanState';

export function useMenu() {
  const [menuIsOpen, openMenu, hideMenu] = useBooleanState(false);
  const menuToggleRef = useRef<HTMLButtonElement>(null);
  const menuId = useId();
  const menuToggleId = useId();
  const menuToggleProps = {
    'aria-controls': menuIsOpen ? menuId : undefined,
    'aria-expanded': menuIsOpen ? true : undefined,
    'aria-haspopup': true,
    id: menuToggleId,
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      openMenu();
    },
    ref: menuToggleRef,
  };
  const menuProps = {
    MenuListProps: {
      'aria-labelledby': menuToggleId,
    },
    anchorEl: menuToggleProps.ref.current,
    id: menuId,
    onClose: hideMenu,
    open: menuIsOpen,
    toggleId: menuToggleId,
  };

  return {
    hideMenu,
    menuIsOpen,
    menuProps,
    menuToggleProps,
    openMenu,
  };
}
